// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/AccountDimensionRule.yaml
// Generated: 2026-05-31T18:48:47.306Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateAccountDimensionRule, UpdateAccountDimensionRule, AccountDimensionRule } from '@/types/finance/AccountDimensionRule';

/**
 * AccountDimensionRule Service
 * CRUD operations for AccountDimensionRule via the ABP API.
 */
export const accountDimensionRuleService = new EntityService<AccountDimensionRule, CreateAccountDimensionRule, UpdateAccountDimensionRule>(
  '/api/finance/accountdimensionrule',
  'AccountDimensionRule',
);
